var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"label":("Show " + (_vm.language.name)),"type":"is-dark","position":"is-bottom"}},[_c('b-button',{class:{
      disabled: _vm.disabled,
      'is-light': _vm.disabled,
    },on:{"click":function($event){return _vm.$emit('click')}}},[_c('LanguageIcon',{attrs:{"language":_vm.language}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }